import { useMemo } from 'react';
import { useEligibleOnboardingLiveEvents } from './useEligibleOnboardingLiveEvents';
import { useEligibleOnboardingResources } from './useEligibleOnboardingResources';
const MAX_CARDS = 4;
export const useOnboardingHomeRow = ({
  skip = false
} = {}) => {
  const {
    events,
    registeredWorkshopCount,
    loading: eventsLoading,
    error: eventsError
  } = useEligibleOnboardingLiveEvents({
    skip
  });
  const {
    playlists,
    recordings,
    loading: resourcesLoading,
    error: resourcesError
  } = useEligibleOnboardingResources({
    skip
  });
  const items = useMemo(() => [...events, ...playlists, ...recordings].slice(0, MAX_CARDS), [events, playlists, recordings]);
  const headerState = registeredWorkshopCount > 0 ? 'continue' : 'get-started';
  return {
    items,
    headerState,
    registeredWorkshopCount,
    hasContent: items.length > 0,
    loading: eventsLoading || resourcesLoading,
    error: eventsError || resourcesError
  };
};